import { render, staticRenderFns } from "./AppointmentUpdated.vue?vue&type=template&id=70eba604"
import script from "./AppointmentUpdated.vue?vue&type=script&lang=js"
export * from "./AppointmentUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports